import { Component, Injector, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 *  Location Widget
 */
@Component({
  selector: 'location-widget',
  templateUrl: './location-widget.component.html',
  styleUrls: ['./location-widget.component.scss']
})
export class LocationWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Widget Title
   */
  title: string;

  /**
  * Constructor
  */
  constructor(injector: Injector,
    public domSanitizer: DomSanitizer) {
    super(injector, 'location', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadEmpty();

    this.title = this.widgetConfig.isProperty ? 'Property Location' : 'Portfolio Location'
    this.widgetData$ = this.widgetService.load(this.widgetConfig.isProperty ? 'propertyLocation' : 'portfolioLocation', this.getReport()).pipe();
  }
}
